import React from "react";

const CheckboxInput = ({
  inputName,
  id,
  value,
  onChangeFn,
  checked,
  className,
  defaultChecked = false,
  labelText,
}) => {
  return (
    <div className="input-wrapper">
      <input
        name={inputName}
        type="checkbox"
        id={id}
        value={value}
        defaultChecked={defaultChecked}
        onChange={(e) => onChangeFn(e)}
        checked={checked}
        className={className}
      />

      <label htmlFor={id} className="checkbox-input">
        <span className="checkbox" />
        {labelText && <p className="text">{labelText}</p>}
      </label>
    </div>
  );
};

export default CheckboxInput;
